export const fontSizes = {
  default: '14px',
  h1: '32px',
  h2: '28px',
  h3: '24px',
  h4: '24px',
  h5: '20px',
  h6: '16px',
  subtitle: '12px',
  smallText: '10px',
  smallerText: '8px',
  placeHolder: '13px',
  sectionTitle: '18px'
};
